import React, { useMemo } from 'react';
import { useLang } from '@/context/LanguageContext';
import patrol from '@/assets/patrol3.png';

// Clickable hotspots mapped over the single combined sponsors image (patrol3.png).
// Positions measured directly from the image alpha channel (percent of width).
const SPONSOR_LINKS = [
  { name: 'Comú de Canillo', href: 'https://www.canillo.ad/', left: 0.0, width: 10.8 },
  { name: 'Creand', href: 'https://creand.ad/persones/', left: 11.3, width: 14.2 },
  { name: 'Visit Andorra', href: 'https://visitandorra.com/es/', left: 26.0, width: 14.5 },
  { name: 'Expansió', href: '', left: 41.4, width: 12.3 },
  { name: 'RTVA', href: 'https://www.rtva.ad/', left: 56.6, width: 15.2 },
  { name: 'Aymara', href: 'https://www.aymara.ad/', left: 75.6, width: 12.8 },
  { name: 'Espai de Música', href: 'https://espaidemusica.com/', left: 90.7, width: 9.3 },
];

export const Sponsors = () => {
  const { t } = useLang();
  // Memoize the clickable subset so it is not recomputed on every render.
  const linkedSponsors = useMemo(() => SPONSOR_LINKS.filter((s) => s.href), []);
  return (
    <section data-testid="sponsors-section" className="relative bg-[var(--cea-lamp-red)] border-t border-black/10 py-14 sm:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <p className="text-left text-xs font-bold tracking-[0.22em] text-white uppercase mb-8">
          {t.sponsors.title}
        </p>

        <div className="relative w-full max-w-5xl">
          <img
            src={patrol}
            alt="Patrocinadors, col·laboradors, media partners i organitzadors"
            loading="lazy"
            className="w-full h-auto select-none"
          />

          {/* Full-surface clickable areas over each logo */}
          {linkedSponsors.map((s) => (
            <a
              key={s.name}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              aria-label={s.name}
              data-testid={`sponsor-link-${s.name.toLowerCase().replace(/\s+/g, '-')}`}
              className="absolute top-0 bottom-0 rounded-md transition-colors duration-200 hover:bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
              style={{ left: `${s.left}%`, width: `${s.width}%` }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
